import { cleanSearchParamsNoModule } from '../actions/searchHistoryActions';
import { cleanSearchText } from '../actions/searchInfoActions';
import {  MODULE_SEARCH_CONFIG_GENERIC } from './moduleSearch.config';
//import * as actions from '../actions/searchActions'; // Ajusta a tus acciones de limpieza

export const dispatchModuleSearch = (dispatch, params, envVars) => {
    const { searchText, moduleKey, page, itemsPerPage, catalogToFilter, indicatorToFilter, codeCiiuLevel1 } = params;

    //console.log("TT2, codeCiiuLevel1",codeCiiuLevel1);
    // Aquí buscamos el objeto dentro de MODULE_SEARCH_CONFIG que coincida con la llave (ej: 'technology')
    const config = MODULE_SEARCH_CONFIG_GENERIC[moduleKey];

    // Verificación de seguridad: texto no vacío, módulo configurado, habilitado en env y código presente
    if (searchText !== "" && config && config.isEnabled(envVars) && codeCiiuLevel1) {
        
        // config.action(params) devuelve la acción de Redux (el thunk)
        // dispatch(...) es lo que realmente la dispara hacia el middleware
        dispatch(config.action({ 
            text: searchText, 
            page: page,
            size: itemsPerPage, 
            catalogToFilter: catalogToFilter, 
            indicatorToFilter: indicatorToFilter,
            codeCiiuLevel1: codeCiiuLevel1 
        }));
        
        return true; // Retornamos true para indicar que se ejecutó una búsqueda
    } 
    else if (searchText !== "" && config && config.isEnabled(envVars)) {
        
        //console.log("TT3");
        // config.action(params) devuelve la acción de Redux (el thunk)
        // dispatch(...) es lo que realmente la dispara hacia el middleware
        dispatch(config.action({ 
            text: searchText, 
            page: page,
            size: itemsPerPage, 
            catalogToFilter: catalogToFilter, 
            indicatorToFilter: indicatorToFilter,
        }));
        
        return true; // Retornamos true para indicar que se ejecutó una búsqueda
    } 
    else {

        //console.log("TT3.1 Clean")
        // Usamos el nuevo helper para limpiar todo
        dispatchModuleClean(dispatch); 
        return false;
    }
};

/*
export const dispatchModuleSearch = (dispatch, params, envVars) => {
    const { searchText, moduleKey, page, itemsPerPage, catalogToFilter, indicatorToFilter, codeCiiuLevel1 } = params;

    // Aquí buscamos el objeto dentro de MODULE_SEARCH_CONFIG que coincida con la llave (ej: 'technology')
    const config = MODULE_SEARCH_CONFIG_GENERIC[moduleKey];

    // Verificación de seguridad: texto no vacío, módulo configurado, habilitado en env y código presente
    if (searchText !== "" && config && config.isEnabled(envVars) && codeCiiuLevel1) {
        
        // config.action(params) devuelve la acción de Redux (el thunk)
        // dispatch(...) es lo que realmente la dispara hacia el middleware
        dispatch(config.action({ 
            text: searchText, 
            page: page,
            size: itemsPerPage, 
            catalogToFilter: catalogToFilter, 
            indicatorToFilter: indicatorToFilter,
            codeCiiuLevel1: codeCiiuLevel1 
        }));
        
        return true; // Retornamos true para indicar que se ejecutó una búsqueda
    } else {
        // Lógica de limpieza cuando no se cumplen las condiciones
        dispatch(cleanSearchParamsNoModule());
        dispatch(cleanSearchText());
        
        // Despachamos todas las limpiezas de paginados
        dispatch(cleanTechnologiesPaginatedS());
        dispatch(cleanAlternativesPaginatedS());
        dispatch(cleanExperiencesPaginatedS());
        dispatch(cleanInnovationsPaginatedS());
        dispatch(cleanAssistancesPaginatedS());
        dispatch(cleanFinancialsPaginatedS());
        dispatch(cleanRegulationsPaginatedS());
        dispatch(cleanVisionsPaginatedS());
        
        return false; // Retornamos false para resetear los estados locales (wasSearched, etc)
    }
};
*/

/**
 * Ejecuta la búsqueda paginada basada en el módulo seleccionado (Reemplaza los if/else)
 */
export const dispatchModulePaginatedSearch = (dispatch, params) => {
    const { searchText, moduleKey, page, itemsPerPage, catalogsToFilter, indicatorsToFilter, codeCiiuLevel1 } = params;

    // Buscamos la configuración del módulo
    const config = MODULE_SEARCH_CONFIG_GENERIC[moduleKey];

    if (config && codeCiiuLevel1) {
        // Ejecutamos la acción mapeada en moduleSearch.config.js
        dispatch(config.action({
            text: searchText,
            page: page,
            size: itemsPerPage,
            catalogToFilter: catalogsToFilter,
            indicatorToFilter: indicatorsToFilter,
            codeCiiuLevel1: codeCiiuLevel1
        }));
        return true;
    }
    else if (config) {
        // Ejecutamos la acción mapeada en moduleSearch.config.js
        dispatch(config.action({
            text: searchText,
            page: page,
            size: itemsPerPage,
            catalogToFilter: catalogsToFilter,
            indicatorToFilter: indicatorsToFilter,
        }));
        return true;
    }
    
    console.warn(`Módulo ${moduleKey} no configurado en MODULE_SEARCH_CONFIG_GENERIC`);
    return false;
};

/**
 * Limpia el estado de un módulo específico o todos si no se envía key
 * @param {Function} dispatch - Redux dispatch
 * @param {string|null} moduleKey - Llave del módulo (ej: 'technology')
 */
export const dispatchModuleClean = (dispatch, moduleKey = null) => {
    // 1. Limpiezas comunes/globales
    dispatch(cleanSearchParamsNoModule());
    dispatch(cleanSearchText());

    if (moduleKey && MODULE_SEARCH_CONFIG_GENERIC[moduleKey]) {
        // 2a. Limpiar solo el módulo solicitado
        const config = MODULE_SEARCH_CONFIG_GENERIC[moduleKey];
        dispatch(config.cleanAction());
    } else {
        // 2b. Limpiar TODOS los módulos (comportamiento actual del else en tu dispatchModuleSearch)
        Object.values(MODULE_SEARCH_CONFIG_GENERIC).forEach(config => {
            if (config.cleanAction) dispatch(config.cleanAction());
        });
    }
};
